<template>
    <div class="c-programmes-search" :class="[background]">
        <div class="o-container">
            <div class="o-form">
                <div class="o-form__item__container">
                    <div class="o-form__item">
                        <label class="o-label sr-only" for="programmes-search">{{ t("Mots clés") }}</label>
                        <input @keyup="keyupSearch()" class="o-input" id="programmes-search" type="text" :placeholder="t('Mots clés')" v-model="searchInput">
                        <svg class="o-ico -ico-search" role="img">
                            <title>search</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#search"></use>
                        </svg>
                    </div>
                    <div class="o-form__item">
                        <label class="o-label sr-only" for="programme-etudes-vise">{{ t("Programme d'études visé") }}</label>
                        <select @change="changeSelectionEtude()" class="o-select" id="programme-etudes-vise" v-model="selectedEtude">
                            <option value="">{{ t("Programme d'études visé") }}</option>
                            <option v-for="etude in etudes" :value="etude">{{ etude }}</option>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                        </svg>
                    </div>
                    <div class="o-form__item">
                        <label class="o-label sr-only" for="domaine-de-recherche">{{ t("Statut") }}</label>
                        <select @change="changeSelectionStatut()" class="o-select" id="domaine-de-recherche" v-model="selectedStatut">
                            <option value="">{{ t("Statut") }}</option>
                            <option v-for="st in statut" :value="st">{{ st }}</option>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                        </svg>
                    </div>
                    <div class="o-form__button c-tooltip__wrap">
                        <button class="o-button -button-bg" type="submit">
                            <span class="o-button__icos">
                                <span class="o-button__ico">
                                    <svg class="o-ico -ico-arrow-full-right" role="img">
                                        <title>arrow-full-right</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=2#arrow-full-right"></use>
                                    </svg>
                                </span>
                                <span class="o-button__ico">
                                    <svg class="o-ico -ico-arrow-full-right" role="img">
                                        <title>arrow-full-right</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=2#arrow-full-right"></use>
                                    </svg>
                                </span>
                            </span>
                            <span class="o-button__text">
                                <span class="o-button__text__elm">
                                    {{ t("Rechercher") }} <span class="sr-only">{{ t("une bourse selon les critères sélectionnés") }}</span>
                                </span>
                            </span>
                        </button>

                        <div class="c-tooltip">
                            <span class="c-tooltip__text">
                                {{ t("Voir les") }} {{ filteredResults.length }} {{ t("résultat") }}{{ filteredResults.length > 1 ? 's' : '' }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="c-programmes-search__filters">
        <div class="o-container">
            <div class="c-programmes-search__filters__wrap">
                <div class="c-programmes-search__filters__total">
                    <span>
                        {{ filteredResults.length }} {{ t("résultat") }}{{ filteredResults.length > 1 ? 's' : '' }}
                    </span>
                </div>
                <div v-if="tags.length" class="c-programmes-search__filters__actives">
                    <div v-for="tag in tags" class="c-programmes-search__filters__actives__item">
                        <span>
                            {{ tag.title }}
                        </span>
                        <button @click.prevent="removeTag(tag)" class="c-programmes-search__filters__remove">
                            <span></span>
                            <span></span>
                            <span class="sr-only">{{ t("Retirer le filtre") }} : {{ tag.title }}</span>
                        </button>
                    </div>
                </div>
                <div class="c-programmes-search__filters__reset">
                    <button @click.prevent="resetSearch()" class="o-button -button-reset">
                        {{ t("Réinitialiser la recherche") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div ref="resultsStart"></div>
    <div   class="o-section__inner" :class="{'-loading': loading}">
        <div class="o-container">
            <div class="c-projects-search__results">
                <template v-for="entry in filteredResultsPaged">
                    <div class="c-search-results__item -show">
                        <div class="c-search-result__header">
                            <span class="c-search-result__title o-title-4">
                                <a :href="entry.url">{{ entry.title }}</a>
                            </span>
                        </div>
                        <div class="c-search-result__desc">
                            <p>
                                {{ entry.description }}
                            </p>
                        </div>
                        <div v-if="entry.etudes.length || entry.statut.length" class="c-search-result__tags">
                            <span v-for="etude in entry.etudes" class="o-tag">
                                <template v-if="etude">{{ etude.replace(/<[^>]*>?/gm, '') }}</template>
                            </span>
                            <span v-for="statut in entry.statut" class="o-tag">
								<template v-if="statut">{{ statut.replace(/<[^>]*>?/gm, '') }}</template>
                            </span>
                        </div>
                </div>
                </template>
            </div>
            <Pager v-if="pagerInfo.totalPages>1" :pagerInfo="pagerInfo" @goToPage="goToPage" />
        </div>
    </div>
</template>

<script>
    import debounce from 'debounce';
    import Pager from './Pager.vue';

    export default {
        props: {
            background: {
                type: String,
                default: ''
            }
        },
        components: {
            Pager
        },
        data() {
            return {
                siteId: 1,
                loading: false,
                searchInput: '',
                searchedIds: null,
                selectedEtude: '',
                selectedStatut: '',
                selectedEtudes:[],
                selectedStatuts:[],
                etudes: [],
                statut: [],
                results: [],
                controller: null,
                languageUrl: '/',
                currentPage: 1
            }
        },
        mounted() {
            let lang = document.documentElement.lang;
            if (lang === 'fr-CA') {
                this.siteId = 1;
            } else {
                this.siteId = 2;
                this.languageUrl = '/en/';
            }

            this.fetchAttributes();
        },
        computed: {
            filteredResults() {
                let filtered = this.results;

                if (this.searchedIds!==null) {
                    if (this.searchedIds.length === 0) return [];
                    filtered = filtered.filter(entry => {
                        return this.searchedIds.includes(entry.id);
                    });

                    filtered.sort((a, b) => {
                        return this.searchedIds.indexOf(a.id) - this.searchedIds.indexOf(b.id);
                    });
                }

                if (this.selectedEtudes.length) {
                    filtered = filtered.filter(entry => {
                        return this.selectedEtudes.some(etude => entry.etudes.includes(etude));
                    });
                }

                if (this.selectedStatuts.length) {
                    filtered = filtered.filter(entry => {
                        return this.selectedStatuts.some(statut => entry.statut.includes(statut));
                    });
                }

                //this.pagerInfo.totalPages = Math.ceil(filtered.length / 10);
                //this.pagerInfo.currentPage = 1;

                return filtered;
            },
            filteredResultsPaged() {
                return this.filteredResults.slice((this.pagerInfo.currentPage - 1) * 10, this.pagerInfo.currentPage * 10);
            },
            pagerInfo() {
                if (this.filteredResults.length === 0) {
                    return {
                        currentPage: this.currentPage,
                        totalPages: 1
                    }
                }

                // console.log(this.filteredResults.length);

                return {
                    currentPage: this.currentPage,
                    totalPages: Math.ceil(this.filteredResults.length / 10)
                }
            },
            tags() {
                let tags = [];

                this.selectedEtudes.forEach(etude => tags.push({type: 'etude', title: etude}));
                this.selectedStatuts.forEach(statut => tags.push({type: 'statut', title: statut}));
                return tags
            }
        },
        methods: {
            t(string) {
                return BourseLocalisation[string];
            },
            fetchAttributes() {
                this.loading = true;
                fetch(this.languageUrl + 'api/search/bourse-index?siteId=' + this.siteId, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json'
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.etudes !== undefined) this.etudes = data.etudes;
                    if (data.statut !== undefined) this.statut = data.statut;
                    if (data.results !== undefined) this.results = data.results;

                    this.pagerInfo.totalPages = Math.ceil(this.results.length / 10);
                    this.loading = false;
                })
            },
            goToPage(page) {
                setTimeout(() => {
                    this.$refs.resultsStart.scrollIntoView({ behavior: 'smooth' });
                    this.currentPage = page;
                }, 500);
            },
            changeSelectionEtude() {
                let current = this.selectedEtude;
                if (current === '') return;
                if (!this.selectedEtudes.includes(current)) {
                    this.selectedEtudes.push(current);
                }
                this.selectedEtude = '';
            },
            changeSelectionStatut() {
                let current = this.selectedStatut;
                if (current === '') return;
                if (!this.selectedStatuts.includes(current)) {
                    this.selectedStatuts.push(current);
                }
                this.selectedStatut = '';
            },
            removeTag(tag) {
                if (tag.type === 'etude') {
                    this.selectedEtudes = this.selectedEtudes.filter(etude => etude !== tag.title);
                } else {
                    this.selectedStatuts = this.selectedStatuts.filter(statut => statut !== tag.title);
                }
            },
            keyupSearch: debounce(function(e) {
                if (this.controller) this.controller.abort();
                if (this.searchInput.length >= 3) {
                    this.search();
                } else {
                    this.searchedIds = null;
                }
            }, 500),
            search() {
                this.loading = true;
                if (this.controller) {
                    this.controller.abort();
                }

                this.controller = new AbortController();

                fetch(this.languageUrl + 'api/search/bourse?s='+this.searchInput+'&siteId=' + this.siteId, {
                    signal: this.controller.signal,
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json'
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        this.searchedIds = data;
                        this.loading = false;
                    })
                    .catch(err => {
                        this.searchedIds = null;
                        this.searchInput = '';
                        this.loading = false;
                    });
            },
            resetSearch() {
                this.searchInput = '';
                this.searchedIds = null;
                this.selectedEtudes = [];
                this.selectedStatuts = [];
            }
        },
    }
</script>